module.exports = __webpack_public_path__ + "media/error1.4a68bb28.mp3";